const _hash = Symbol();

export class State {
	constructor() {
		this[_hash] = {};
	}
	set(key, val, overwrite) {
		if(typeof key !== 'string')
			throw new TypeError('key must be a string.');
		if(this[_hash][key] !== undefined && !overwrite)
			throw new Error('key already exists and overwrite not specified.');
		this[_hash][key] = val;
	}
	get(key, destroy) {
		if(typeof key !== 'string')
			throw new TypeError('key must be a string.');
		if(destroy !== undefined && typeof destroy !== 'boolean')
			throw new TypeError('destroy must be a boolean.');

		const val = this[_hash][key];
		if(destroy)
			this.delete(key);
		return val;
	}
	delete(key) {
		if(typeof key !== 'string')
			throw new TypeError('key must be a string.');
		delete this[_hash][key];
	}
}